var classes = {"infoBanner":"oWmAV","infoBannerContent":"chMq3"};

export { classes as default };
